// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Sp\u00e4\u0165 na hlavn\u00fa str\u00e1nku";
export const BLOGS_FEED_ALL = "V\u0161etky pr\u00edspevky";
export const BLOGS_FEED_FILTER_POST_TYPE = "Zobrazuj";
export const CREATE_ALBUM = "Vytvor album";
export const DRAFTS = "Rozp\u00edsan\u00e9 \u010dl\u00e1nky";
export const HOMEPAGE_POST_TYPE_SHORT_MESSAGE = "Kr\u00e1tka spr\u00e1va";
export const PB_MENU_ALBUMS = "Albumy";
export const PB_MENU_POSTS = "\u010cl\u00e1nky";
export const PB_MENU_SHORT_MESSAGES = "Kr\u00e1tke spr\u00e1vy";
export const PROFILE__POSTS_FOR_REGISTRED_USERS_ARE_NOT_DISPLAYING_TO_YOU = "Pr\u00edspevky pre registrovan\u00fdch pou\u017e\u00edvate\u013eov sa ti nezobrazuj\u00fa.";
export const THIS_PHOTOBLOG_IS_STILL_EMPTY = "Tento profil je zatia\u013e pr\u00e1zdny";
export const WRITE_ARTICLE = "Nap\u00ed\u0161 \u010dl\u00e1nok";
